import { ApiResponse, GlobalStore, GridStore } from "@roc/feature-app-core";
import { NewLeadService } from "@roc/feature-new-lead";
import { GENERIC_ERROR_MESSAGE } from "@roc/feature-utils";
import { flow, makeObservable, observable } from "mobx";

import { BaseLeadStore } from "libs/client-portal-shared/src/app/modules/companyProfile/stores/baseLeadStore/BaseLeadStore";
import { CadenceStore } from "libs/client-portal-shared/src/app/modules/companyProfile/stores/cadenceStore/cadenceStore";
import { CadenceService } from "libs/client-portal-shared/src/app/modules/companyProfile/services/cadenceServices/cadenceService";

const PAGE_SIZE = 100;
export class ProspectsByOriginatorGridStore extends GridStore {
  private globalStore: GlobalStore;
  private cadenceStore: CadenceStore;
  private cadenceService: CadenceService;

  constructor(globalStore: GlobalStore, cadenceStore) {
    super(() => this.fetchRows(), undefined, PAGE_SIZE);
    this.globalStore = globalStore;
    this.cadenceStore = cadenceStore;
    this.cadenceService = new CadenceService();
  }

  fetchRows = async () => {
    try {
      if (!this.cadenceStore.cadence.isStandard) {
        return await this.prospectsByOriginatorForCustomList();
      } else {
        return await this.prospectsByOriginatorForStandardList()
      }
    } catch (error) {
      this.globalStore.notificationStore.showErrorNotification({
        message: GENERIC_ERROR_MESSAGE
      });
    }
  };

  prospectsByOriginatorForStandardList = async () => {
    const { currentDashboardId } = this.cadenceStore;
    const response: ApiResponse = await this.cadenceService.getProspectsByOriginatorForStandardList(
      currentDashboardId?.value,
      this.cadenceStore.cadence?.cadenceId,
      this.gridData.meta.pageNumber,
      this.gridData.meta.pageSize,
      this.gridData.meta.sortBy,
      this.gridData.meta.sortDir,
      this.gridData.meta.filters,
      this.gridData.meta.dropdownFilters,
      this.cadenceStore.gridBusinessUnit
    );
    return response;
  }

  prospectsByOriginatorForCustomList = async () => {
    const { currentDashboardId } = this.cadenceStore;
    const response: ApiResponse = await this.cadenceService.getProspectsByOriginatorForCustomList(
      currentDashboardId?.value,
      this.cadenceStore.cadence?.cadenceId,
      this.gridData.meta.pageNumber,
      this.gridData.meta.pageSize,
      this.gridData.meta.sortBy,
      this.gridData.meta.sortDir,
      this.gridData.meta.filters,
      this.gridData.meta.dropdownFilters,
      this.cadenceStore.gridBusinessUnit
    );
    return response;
  }

}